import PageWrapper from '@/components/page-wrapper'
import SectionCta from '@/components/section/cta'
import { SetOfCardsSectionComponent } from '@/components/section/set-of-cards'
import Faqs from '@/components/section/faqs'

import Hero from '@/data-security-in-age-of-ai/sections/hero'
import Stats from '../data-security-in-age-of-ai/sections/stats'
import Testimonial from '../data-security-in-age-of-ai/sections/testimonial'
import Recommendations from '../data-security-in-age-of-ai/sections/recommendations'

import DiamondsLeft from '../data-security-in-age-of-ai/graphics/diamonds-left'
import DiamondsMiddle from '../data-security-in-age-of-ai/graphics/diamonds-middle'
import DiamondsBottom from '../data-security-in-age-of-ai/graphics/diamonds-bottom'
import {
  TypeComponentCtaLink,
  TypeComponentHubspotCta,
  TypeLandingSettings,
  TypeComponentHubSpotForm,
  TypeSectionSetOfCards,
  TypeSectionFaqs,
  TypeSectionCta,
} from '@/types/ctf'
import { cx } from '@/utils/strings'
// import Contact from '../data-security-in-age-of-ai/components/contact'

type H2Props = {
  settings: TypeLandingSettings<'WITHOUT_UNRESOLVABLE_LINKS'>
  setOfCards: TypeSectionSetOfCards<'WITHOUT_UNRESOLVABLE_LINKS'>
  faqs: TypeSectionFaqs<'WITHOUT_UNRESOLVABLE_LINKS'>
  sectionCta: TypeSectionCta<'WITHOUT_UNRESOLVABLE_LINKS'>
  ctaLink: TypeComponentCtaLink<'WITHOUT_UNRESOLVABLE_LINKS'>
  hubspotCta: TypeComponentHubspotCta<'WITHOUT_UNRESOLVABLE_LINKS'>
  hubspotForm: TypeComponentHubSpotForm<'WITHOUT_UNRESOLVABLE_LINKS'>
  headerNav: any
  footerNav: any
  seo: any
  headerBanners: any
  newsletterForm: any
}

export default function DataSecurityInAgeOfAi({
  settings,
  setOfCards,
  faqs,
  sectionCta,
  headerBanners,
  headerNav,
  footerNav,
  newsletterForm,
  seo,
}: H2Props) {
  const settingsJson = settings.fields.settings as {
    hero: any
    stats: any
    testimonial: any
    recommendations: any
    hubspotFormId: string
  }
  if (!settings) return
  return (
    <PageWrapper
      headerNav={headerNav}
      footerNav={footerNav}
      seo={seo}
      headerBanners={headerBanners}
      newsletterForm={newsletterForm}
    >
      <div className="relative pb-24 md:pb-36 overflow-hidden">
        <div className="relative z-1">
          {/* <Contact {...hubspotForm} /> */}
          <Hero {...settingsJson.hero} />
          <Stats {...settingsJson.stats} />
          <Testimonial {...settingsJson.testimonial} />
          <Recommendations {...settingsJson.recommendations} />
          <div className="hidden mb-36 md:block [&_svg]:fill-none [&_svg]:w-full">
            <SetOfCardsSectionComponent {...setOfCards} />
          </div>
          <div className="relative">
            <div
              className={cx(
                `hidden md:block absolute top-0 right-0 left-0 m-auto -z-1 w-full h-auto max-w-(--breakpoint-2xl) translate-y-[-160px]`
              )}
            >
              <DiamondsMiddle />
            </div>
          </div>
          <div className="hidden mb-36 md:block">
            <Faqs {...faqs.fields} backgroundColor="None" />
          </div>
          <SectionCta {...sectionCta.fields} />
        </div>
        <div className="hidden md:block absolute top-[42vh] left-0 z-0 w-[500px] h-auto [&_svg]:fill-none [&_svg]:w-full">
          <DiamondsLeft />
        </div>
        <div
          className={cx(
            `md:hidden absolute bottom-0 right-0 left-0 m-auto z-0 w-full h-auto max-w-(--breakpoint-2xl) scale-[1.9] translate-x-[-10px] translate-y-[70px]`,
            `[&_svg]:fill-none [&_svg]:w-full`
          )}
        >
          <DiamondsBottom />
        </div>
      </div>
    </PageWrapper>
  )
}
